import IconButton from "./IconButton";
import {useState} from "react";
import {useContext} from "react";
import {useIntl} from "react-intl";
import {NotificationsContext} from "./Notifications";
const ActionButtonComponent = (
	{
		icon,
		action,
		text,
		...rest
	}
) => {

	const [loading, setLoading] = useState(false);
	const { push } = useContext(NotificationsContext);
	const intl = useIntl();

	return (
		<div>
			<IconButton
				Icon={icon}
				submitting={loading}
				onClick={ async () => {
					setLoading(true);
					try {
						await action(setLoading)
					} catch (error) {
						push({title: intl.formatMessage({id:"server_error"}), type: "error"});
					}
					finally {
						setLoading(false);
					}
				}}
				{...rest}
				>
				{text}
			</IconButton>
		</div>
	)
}

export default ActionButtonComponent;